import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {GroupedCheckboxFilterGroup} from "./grouped-checkbox-filter-group";
import {GroupedCheckboxFilterData} from "./grouped-checkbox-filter-data";
import {AppState} from "../../store";
import {Store} from "@ngrx/store";
import {setUpdateArchiveView, toggleSelectedRequirement} from "../../store/actions/filter.actions";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {IconsService} from "../../services/icons.service";
import {UtilsService} from "../../services/utils.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-grouped-checkbox-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './grouped-checkbox-filter.component.html',
  styleUrls: ['./grouped-checkbox-filter.component.scss']
})
export class GroupedCheckboxFilterComponent implements Overlayable, OnInit, OnDestroy {

  @ViewChild('inputEl') inputEl!: ElementRef<HTMLInputElement>;

  @Input('data') set setGroups(val: GroupedCheckboxFilterData) {
    this.groups = JSON.parse(JSON.stringify(val.groups));
    // this.filteredGroups = this.groups;
    this.filterKey = val.filterKey;
  }
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Output('filterChanged') filterChanged = new EventEmitter<void>();

  searchString = "";
  searchStringLC = "";
  filterKey = "";

  groups: GroupedCheckboxFilterGroup[] = [];


  constructor(
    private store: Store<AppState>,
    private cdRef: ChangeDetectorRef,
    private iconService: IconsService,
    private utils: UtilsService) {
  }

  ngOnInit() {
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe((val) => {
      if(this.groups.length) {
        this.groups = this.groups.map((group) => {
          let localGroup = group;
          localGroup.options = localGroup.options.map((option) => {
            return {...option, selected: val.includes(option.id)};
          });
          return localGroup;
        });
      }
      this.cdRef.detectChanges();
    })
  }

  ngOnDestroy() {
    this.store.dispatch(setUpdateArchiveView({updateActive: true}));
  }

  searchStringChanged() {
    this.searchStringLC = this.searchString.toLowerCase();
    this.groups = this.groups.map((group) => {
      let localGroup = group;
      localGroup.options = localGroup.options.map((option) => {
        return {...option, visible: option.label.toLowerCase().indexOf(this.searchStringLC) !== -1};
      });

      return localGroup;
    });

    this.filterChanged.emit();
  }

  toggleOption(id: number) {
    this.store.dispatch(toggleSelectedRequirement({requirementId: id}));
  }

  optionTracker(index: any, item: any) {
    return item.id;
  }

  groupTracker(index: any, item: any) {
    return item.title;
  }

  getIconById(id: number): string {
    return this.iconService.getRequirementIconById(id);
  }

  clearInput() {
    this.searchString = "";
    this.searchStringChanged();
    this.inputEl.nativeElement.focus();
  }

  isAnyVisibleInGroup(group: GroupedCheckboxFilterGroup): boolean {
    return group.options.some((el) => el.visible);
  }

  addLeadingZero(num: number) {
    return this.utils.getNumberWithLeadingZero(num);
  }
}
